import { DrinkServiceLolPromiseClient } from '../generated/drinks_grpc_web_pb';
import GRPC_BACKEND_URL from '../grpcConfig';

// Shared by every caller in this app, same pattern as usernatorClient in src/hooks/useFriends.ts:
// one grpc-web client instance, not one per caller. Drinks live on the same Saufdings origin as
// login/friends (there is no separate "drinks backend" URL), so this reuses GRPC_BACKEND_URL
// rather than introducing a second one.
export const drinksClient = new DrinkServiceLolPromiseClient(GRPC_BACKEND_URL, null, null);
